"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarLayout = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var useCarEditLoad_1 = require("../../hook/useCarEditLoad");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var layout_1 = __importDefault(require("antd/es/layout"));
var menu_1 = __importDefault(require("antd/es/menu"));
var Content = layout_1.default.Content, Sider = layout_1.default.Sider;
var CarLayout = function () {
    var id = (0, react_router_dom_1.useParams)().id;
    var location = (0, react_router_dom_1.useLocation)();
    var car = (0, react_redux_1.useSelector)(selectors_1.editCarSelector).car;
    (0, useCarEditLoad_1.useCarEditLoad)();
    var getSelectedKey = function () {
        var path = location.pathname;
        if (path.endsWith("/car/".concat(id)))
            return 'edit-car-main-info';
        if (path.includes('/history'))
            return 'edit-car-history';
        if (path.includes('/complectation'))
            return 'edit-car-complectation';
        if (path.includes('/images'))
            return 'edit-car-images';
        return 'edit-car-main-info';
    };
    var menuItems = [
        {
            key: 'edit-car-main-info',
            icon: react_1.default.createElement(icons_1.CarOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/car/".concat(id) }, "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
        },
        {
            key: 'edit-car-history',
            icon: react_1.default.createElement(icons_1.HistoryOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/car/".concat(id, "/history") }, "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043C\u0430\u0448\u0438\u043D\u044B"),
        },
        {
            key: 'edit-car-complectation',
            icon: react_1.default.createElement(icons_1.ToolOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/car/".concat(id, "/complectation") }, "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438"),
        },
        {
            key: 'edit-car-images',
            icon: react_1.default.createElement(icons_1.PictureOutlined, null),
            label: react_1.default.createElement("a", { href: "/admin/car/".concat(id, "/images") }, "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"),
        },
    ];
    if (!car)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(layout_1.default, { style: { minHeight: '100vh', backgroundColor: '#fff' } },
        react_1.default.createElement(Sider, { width: 300 },
            react_1.default.createElement(menu_1.default, { mode: "inline", selectedKeys: [getSelectedKey()], style: { height: '100%', borderRight: 0, paddingTop: '24px' }, items: menuItems })),
        react_1.default.createElement(layout_1.default, { style: { paddingLeft: '24px' } },
            react_1.default.createElement(Content, { style: {
                    padding: '24px',
                    margin: 0,
                    background: '#fff',
                    borderRadius: '8px',
                } },
                react_1.default.createElement(react_router_dom_1.Outlet, null)))));
};
exports.CarLayout = CarLayout;
